import React from "react";

import { BlackTextButton } from "../black-text-button/black-text-button.styles";
import { connect } from "react-redux";
import { showAlertAction } from "../../redux/alert/alert.actions";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

const normalizeEmail = email => {
	if (typeof email !== "string") {
		return "";
	}

	return email.trim().toLowerCase();
};

const ForgotPasswordButton = ({ showAlert }) => {
	const forgotPasswordClicked = () => {
		showAlert({
			title: "Reset password",
			description: "Where should we send the password reset email?",
			buttons: [
				{
					title: "cancel",
					styles: "background-color:gray;margin-right:5px;",
				},
				{
					title: "Send",
					onClick: email => {
						const normalizedEmail = normalizeEmail(email);
						if (!normalizedEmail) {
							showAlert({
								title: "Oops.",
								description: "Please enter the email address for your account.",
								buttons: [
									{
										title: "cancel",
										styles: "background-color:gray;margin-right:5px;",
									},
									{
										title: "retry",
										onClick: forgotPasswordClicked,
									},
								],
							});
							return;
						}

						const auth = getAuth();
						sendPasswordResetEmail(auth, normalizedEmail)
							.then(() => {
								showAlert({
									title: "Success",
									description:
										"If an account exists for that email, please check your inbox and spam folder for the reset link.",
								});
							})
							.catch(error => {
								showAlert({
									title: "Oops.",
									description: error.message,
									buttons: [
										{
											title: "cancel",
											styles: "background-color:gray;margin-right:5px;",
										},
										{
											title: "retry",
											onClick: () => {
												forgotPasswordClicked();
											},
										},
									],
								});
							});
					},
					getInputByID: "email",
				},
			],
			inputs: [{ id: "email" }],
		});
	};
	return (
		<BlackTextButton onClick={forgotPasswordClicked}>
			forgot password?
		</BlackTextButton>
	);
};

const mapDispatchToProps = dispatch => ({
	showAlert: alert => dispatch(showAlertAction(alert)),
});

export default connect(null, mapDispatchToProps)(ForgotPasswordButton);
